import { AnimatePresence, LazyMotion, m } from "framer-motion";
import { useState } from "react";
const loadFeatures = () =>
  import("utilities/framerFeatures.js").then((res) => res.default);

export interface FilterAccordionProps {
  className?: string;
  title?: string | null;
  content?: string;
  i: number;
  open?: boolean;
  children?: React.ReactNode;
  onToggle?: (i: number) => void;
}

const FilterAccordion = ({
  className,
  title,
  i,
  open,
  children,
  onToggle,
}: FilterAccordionProps) => {
  const [expanded, setExpanded] = useState(open);

  const handleToggle = () => {
    setExpanded(!expanded);
    if (onToggle) {
      onToggle(i);
    }
  };

  return (
    <LazyMotion features={loadFeatures}>
      <m.li
        className={`${className} flex max-h-[400px] w-full cursor-pointer flex-col overflow-scroll border-b border-gray-300 py-2 transition-all duration-500 ease-in-out`}
      >
        {title ? (
          <m.header
            className={`sticky -top-2 z-20 flex items-center justify-center bg-white`}
          >
            <button
              type="button"
              aria-label={`
                ${expanded ? `Collapse` : `Expand`}
            `}
              className={`px-4 py-2 font-body text-2xl flex items-center justify-between w-full`}
              onClick={handleToggle}
            >
              <h2 className={`max-w-[90%] text-lg text-dark md:text-2xl`}>
                {title}
              </h2>
              {expanded ? `-` : `+`}
            </button>
          </m.header>
        ) : null}
        <AnimatePresence initial={false}>
          {expanded ? (
            <m.section
              className={`font-body text-lg text-gray-800`}
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              {children}
            </m.section>
          ) : null}
        </AnimatePresence>
      </m.li>
    </LazyMotion>
  );
};

export default FilterAccordion;
